import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const getAdminOverview = ()=>{
  return api.get(ENDPOINTS.ADMIN_OVERVIEW.DASHBOARD);
};